import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'

import { Store as OverflowMenuStore } from './store'

@ngCore.Component({
  imports: [ds.overlay.attached.Component],
  providers: [OverflowMenuStore],
  selector: 'atn-widget-overflow-menu',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  private readonly _currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )
  /** @see {@link state.mosaic.aliases.Feature} */
  private readonly _aliasesFeature = ngCore.inject(state.mosaic.aliases.Feature)
  /** @see {@link OverflowMenuStore} */
  public readonly overflowMenuStore = ngCore.inject(OverflowMenuStore)

  /** @see {@link ents.core.mosaic.Action.Ref.WithIcon} */
  // This component cannot utilize 'AtnMosaicWidgetStore' as it functions as a
  // child component within another widget component
  public readonly actionsSg = ngCore.input<
    readonly ents.core.mosaic.Action.Ref.WithIcon[],
    readonly ents.core.mosaic.Action.Ref.WithIcon[] | undefined
  >([], {
    alias: 'actions',
    transform: input => input ?? [],
  })

  /** @see {@link state.mosaic.models.widget.Ref.Id} */
  public readonly refIdSg = ngCore.input<
    state.mosaic.models.widget.Ref.Id | undefined
  >(undefined, { alias: 'refId' })

  /** @see {@link ents.core.mosaic.Widget.Id} */
  private readonly _widgetIdSg = ngCore.computed((refId = this.refIdSg()) => {
    if (!refId) {
      return undefined
    }

    const widgetRef = this._currentRendering.subfeatures.widgets.selectors
      .getWidgetRef(refId)
      .asSignal()

    if (!widgetRef) {
      return undefined
    }

    return this._aliasesFeature.selectors
      .getWidgetId(widgetRef.widget)
      .asSignal()
  })

  /** TODO:  */
  public readonly actionHandlerLookupSg = ngCore.computed(
    (
      actions = this.actionsSg(),
      context = this._currentRendering.selectors.context.asSignal(),
      refId = this.refIdSg(),
      widgetId = this._widgetIdSg(),
    ) => {
      if (context && refId && widgetId) {
        return actions.map(actionRef =>
          this._currentRendering.subfeatures.actions.createActionHandler(
            `OverflowMenu.Action-${actionRef.name}.Clicked`,
            {
              ...context,
              actionRef,
              widget: {
                id: widgetId,
                refId,
              },
            },
          ),
        )
      }

      // Return empty array when context, refId or widgetId are unavailable as
      // handlers cannot be created
      return []
    },
  )

  /** @see {@link ents.core.common.FlexibleIdentifier.isFlexibleIdentifier}  */
  // NOTE: Exposing flexible identifier typechecker to html
  public readonly isFlexibleIdentifier =
    ents.core.common.FlexibleIdentifier.isFlexibleIdentifier
}
